import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { toast } from 'react-toastify';
import {
  IntlProvider, load, LocalizationProvider, loadMessages
} from '@progress/kendo-react-intl';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';
import numbers from 'cldr-numbers-full/main/pt/numbers.json';
import caGregorian from 'cldr-dates-full/main/pt-PT/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/pt-PT/dateFields.json';
import timeZoneNames from 'cldr-dates-full/main/pt-PT/timeZoneNames.json';
import currencies from 'cldr-numbers-full/main/pt-PT/currencies.json';
import * as serviceWorker from './serviceWorker';
import store, { history } from './store';
import App from './App';
import esMessages from './lang/tlklang.json';
import 'react-toastify/dist/ReactToastify.css';
import 'antd/dist/antd.css';

load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  currencies,
  caGregorian,
  dateFields,
  timeZoneNames
);

loadMessages(esMessages, 'pt-PT');

toast.configure();

ReactDOM.render(
  <LocalizationProvider language="pt-PT">
    <IntlProvider locale="pt-PT">
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </IntlProvider>
  </LocalizationProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
